import { writable } from 'svelte/store'

export const currentUser = writable(null)
export const userInfo = writable(null)

export const filesToAdd = writable([])

export const loadingImages = writable(false)